import React, { useEffect } from "react";

const Carrito = ({ carrito, setCarritoVisible, calcularTotal,calcularTotalDescuento, enviarPedidoWhatsApp, actualizarCantidad, eliminarProducto, vaciarCarrito, loading }) => {

    // Cerrar con tecla Escape y bloquear el scroll del fondo mientras el carrito está abierto
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === "Escape") setCarritoVisible(false);
        };

        document.addEventListener("keydown", handleKeyDown);
        const scrollPrevio = document.body.style.overflow;
        document.body.style.overflow = "hidden";

        return () => {
            document.removeEventListener("keydown", handleKeyDown);
            document.body.style.overflow = scrollPrevio;
        };
    }, [setCarritoVisible]);

    return (
        <div className="carrito-modal carrito-visible">
            <div className="carrito-contenido">
            <div className="carrito-header">
                <h2>🛒 Carrito de Compras</h2>
                <div className="carrito-header-acciones">
                    {carrito.length > 0 && (
                        <button className="vaciar-carrito" onClick={vaciarCarrito}>Vaciar</button>
                    )}
                    <button className="cerrar-carrito" onClick={() => setCarritoVisible(false)}>✖</button>
                </div>
            </div>

            {carrito.length === 0 ? (
                <p className="carrito-vacio">El carrito está vacío</p>
            ) : (
                <>
                <div className="carrito-lista">
            {carrito.map((item) => (


                    <div className="carrito-item" key={item.uid}>
                        <img
                            className="carrito-img"
                            src={"imgBL/150x150/"+item.url_img}
                            alt={item.nombre}
                            onError={(e) => {
                                e.target.src = "imgBL/150x150/Imagen default limpi.webp"; // imagen por defecto
                            }}
                        />
                        <div className="carrito-detalle">
                            <p className="carrito-item-name">{item.nombre}</p>
                            <div className="carrito-cantidad">
                                <button className="carrito-button" onClick={() => actualizarCantidad(item.uid, item.cantidad - 1)} aria-label="Restar">➖</button>
                                <span>{item.cantidad}</span>
                                <button className="carrito-button" onClick={() => actualizarCantidad(item.uid, item.cantidad + 1)} aria-label="Sumar">➕</button>
                            </div>
                        </div>
                        <div className="carrito-pre">
                            <div className="carrito-precio-lista">
                                Lista $ {(item.cantidad * item.precio).toLocaleString("es-ES", { minimumFractionDigits: 2 }) }
                            </div>
                            <div className="carrito-precio">
                                $ {(item.cantidad * (Math.ceil((item.precio * 0.9) / 100) * 100)).toLocaleString("es-ES", { minimumFractionDigits: 2 }) }
                            </div>
                            <button className="carrito-eliminar" onClick={() => eliminarProducto(item.uid)} aria-label="Quitar producto">✖</button>
                        </div>
                    </div>
            ))}

                    
                </div>

        <div className="carrito-footer">
        <div className="carrito-total">
            <div className="precio-bloque">
                <span className="precio-lista">Precio de lista ${calcularTotal().toLocaleString("es-ES", { minimumFractionDigits: 2 })}</span>
                <div className="precio-transferencia">
                    <span className="precio-transferencia-valor">${calcularTotalDescuento().toLocaleString("es-ES", { minimumFractionDigits: 2 })}</span>
                    <span className="precio-transferencia-label">Total con transferencia o efectivo</span>
                </div>
            </div>
        </div>
        
            <button className="boton-finalizar" disabled={loading} onClick={enviarPedidoWhatsApp}>{loading ? "Redirigiendo a Whatsapp..." : "Finalizar Pedido"}</button>
            <button className="boton-seguir" onClick={() => setCarritoVisible(false)}>Seguir Comprando</button>
        </div>
</>
            )}
        </div>

</div>
    );
};

export default Carrito;